import { createSlice } from '@reduxjs/toolkit'

import { UsageReport, UsageReport2 } from 'common/api/v1/types'
import { readUsage, readUsage2 } from '../actions/usageActions'
import { createLoadingReducer } from './shared'

interface State {
  usage?: UsageReport
  usage2?: UsageReport2
  loading: boolean
  error: boolean
}
export const initialStateUsage: State = {
  usage: undefined,
  loading: false,
  error: false,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(readUsage2)

export const usageSlice = createSlice({
  name: 'usage',
  initialState: initialStateUsage,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(readUsage.pending, (state): State => ({ ...state, error: false, usage: undefined }))
      .addCase(readUsage.fulfilled, (state, { payload: usage }): State => ({ ...state, error: false, usage }))
      .addCase(readUsage.rejected, (state): State => ({ ...state, error: true, usage: undefined }))

      .addCase(readUsage2.pending, (state): State => ({ ...state, error: false, usage2: undefined }))
      .addCase(readUsage2.fulfilled, (state, { payload: usage2 }): State => ({ ...state, error: false, usage2 }))
      .addCase(readUsage2.rejected, (state): State => ({ ...state, error: true, usage2: undefined }))

      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default usageSlice.reducer
